export default [

     {
          path: '/risk-zone',
          name: 'RiskZone',
          component: () => import("@/views/Page/RiskZone/RiskZone.vue"),
          meta: {
               title: 'Risk Zone',
          },
     }
];